export default {
  getOrderData: state => state.orderEdited,
  getOrderWorkflow: state => state.orderWorkflow,
  getOrderStatuses: state => state.orderStatuses,
  getOrders: state => state.orders,
  getStatuses: state => state.statuses,
  getTypes: state => state.types,
  statisticsByStartAt: state => state.statisticsByStartAt,
  getTransportHistory: state => state.transportHistory,
}
